<template>
  <label class="ui-switch" :class="{ 'checked': internalValue }">
    <input type="checkbox"
    class="ui-switch-input"
    :value="internalValue"
    v-bind="$attrs"
    v-on:click="toggleValue">

    <div class="ui-switch-track"></div>
    <div class="ui-switch-thumb"></div>

    <div class="ui-switch-focus-ring"></div>
</label>
</template>

<script>
export default {
  name: 'AppToggleInput',
  status: 'prototype',
  release: '1.0.0',
  inheritAttrs: false,
  props: {
    value: {
      required: true,
      default: false
    }
  },
  data () {
    return {
      lazyValue: this.value
    }
  },
  computed: {
    internalValue: {
      get () {
        return this.lazyValue
      },
      set (val) {
        this.lazyValue = val
        this.$emit('input', val)
      }
    }
  },
  methods: {
    toggleValue () {
      if (this.internalValue) {
        this.internalValue = false
      } else {
        this.internalValue = true
      }
    }
  },
  watch: {
    value (val) {
      this.lazyValue = val
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";

.ui-switch {
    position: relative;
    &.checked {
        .ui-switch-track {
            background-color: rgba(152, 113, 221, 0.36)
        }
        .ui-switch-thumb {
            left: 14px;
            background-color: #673ab7;
        }
    }
}
.ui-switch-track {
    position: absolute;
    top: ( (20px - 14px) / 2 );

    height: 14px;
    width: 34px;

    background-color: #eff3f8;
    border-radius: 8px;

    transition: background-color 0.1s linear;
}
.ui-switch-thumb {
    position: absolute;
    top: 0;
    left: 0;

    width: 20px;
    height: 20px;

    border-radius: 50%;
    background-color: #838383;

    box-shadow: 0 1px 3px rgba(48, 48, 48, 0.16);

    transition: all 0.2s ease;
}
.ui-switch-input {
    position: absolute;
    opacity: 0;
}
</style>
